import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { useScheduleEvents } from 'src/Hooks/useScheduleEvents'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

export const useScheduleStartEvent = (): void => {
  const { number: campaignIdParams } = useParams()
  const { handleScheduleStartEvent } = useScheduleEvents()
  const { campaignDetails } = useSpotifyCampaignStatus()
  const campaignId = campaignDetails?.id
  const campaignType = campaignDetails?.type || CampaignTypeEnum.BASIC
  const campaignGenres = campaignDetails?.genres
    ?.map((genre) => genre.name)
    .join(' ')

  useEffect(() => {
    if (String(campaignId) !== String(campaignIdParams)) {
      return
    }

    handleScheduleStartEvent({
      campaignType,
      platformName: CampaignPlatformTypeEnum.SPOTIFY,
      campaignId: Number(campaignId),
      genreList: campaignGenres,
    })
  }, [
    handleScheduleStartEvent,
    campaignId,
    campaignIdParams,
    campaignType,
    campaignGenres,
  ])
}
